'use client';

import { useTargetMbox } from '@webmotors/anunciar.tools';

type UseExperiementClientSideProps = {
    mbox: string;
};

const UseExperiementClientSide = ({ mbox }: UseExperiementClientSideProps) => {
    let response = '';
    if (mbox) {
        response = useTargetMbox({ mbox: mbox, key: 'ab_teste_ofertas' });
    }
    return null;
};

export default UseExperiementClientSide;